import TooManyTrustedDevices from './TooManyTrustedDevices';

export default TooManyTrustedDevices;